import { styled } from '@uhg-abyss/web/tools/styled';

import { desktopOnly, mobileOnly, notMobile } from '../../ConstantsStyles';

export const ModalOverlayStyles = {
  'abyss-modal-base-overlay': {
    background: 'rgba(0, 0, 0, 0.5)',
  },
  'abyss-modal-base-body': {
    padding: 0,
    rowGap: 0,
  },
  'abyss-modal-base-header-container': {
    marginTop: 0,
    padding: 0,
  },
  'abyss-modal-base-close-button': {
    [`@media ${mobileOnly}`]: {
      marginTop: '20px',
      marginRight: '20px',
    },
  },
  'abyss-modal-base-content-container': {
    padding: '40px 48px',
    borderRadius: '16px',
    width: '583px',
    maxWidth: '100%',
    [`@media ${mobileOnly}`]: {
      padding: '24px', // all sides 24px — overrides cleanly now
    },
    [`@media ${notMobile}`]: {
      width: '928px',
    },
    [`@media ${desktopOnly}`]: {
      width: '1152px',
    },
  },
  'abyss-modal-base-footer': {
    padding: 0,
    marginRight: '-96px',
  },
};

export const descriptionTextCss = {
  display: 'block',
  paddingTop: '$sm',
  paddingBottom: '$lg',
  color: '#42474D',
  width: '538px',
  maxWidth: '100%',
  [`@media ${mobileOnly}`]: {
    width: '100%',
  },
  // fontFamily: 'AbyssEnterpriseSansVF, Arial Bold, sans-serif !important',
};

export const Divider = styled('div', {});

export const StyledModalFooter = styled('div', {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  paddingRight: '48px',
  height: '66px',
  borderBottomLeftRadius: '16px',
  borderBottomRightRadius: '16px',
  backgroundColor: '$core.color.neutral.10',
  // Break out of the modal content padding so the footer is full-bleed.
  // Content container padding is 48px sides / 40px bottom (24px on mobile).
  marginLeft: '-48px',
  marginRight: '-48px',
  marginBottom: '-40px',
  [`@media ${mobileOnly}`]: {
    marginLeft: '-24px',
    marginRight: '-24px',
    marginBottom: '-24px',
  },
});
